module.exports = __webpack_public_path__ + "static/media/jack-darknet.adde3dd4.jpg";